import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import * as _ from 'underscore';
import { DataService } from '../../data.service';
import { tap } from 'rxjs/operators';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DownloadModalComponent } from './download-modal/download-modal.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { Download } from 'src/app/_helpers/download';
import { DownloadService } from 'src/app/_services/download.service';

@Injectable({
  providedIn: 'root'
})
export class DownloadsService {

  downloadFiles$: Observable<any>;

  downloadsFilesObs = new BehaviorSubject<any>({});
  downloadsFiles$ = this.downloadsFilesObs.asObservable();

  downloads;
  downloadsObs = new BehaviorSubject<any>({});
  downloads$ = this.downloadsObs.asObservable();

  categories = [];

  getCurrentCategory(slug) {
    return _.findWhere(this.categories, { slug: slug });
  }

  constructor(
    private readonly dataService: DataService,
    private downloadsService: DownloadService,
    private readonly ngxSmartModalService: NgxSmartModalService,
    private readonly _toastService: ToastrService
  ) {
    // this.getItems();
  }

  newDownload(url, name, fileName?) {
    const id = Date.now();
    const saveName = `${name} ${fileName}`;
    let download$: Observable<Download>;
    download$ = this.downloadsService.download(url, saveName);
    download$.subscribe(val => {

      val['name'] = saveName;
      const current = this.downloadsFilesObs.value;
      if (val.state === 'DONE') {
        delete current[id];
      } else {
        current[id] = val;
      }
      this.downloadsFilesObs.next(current);
    }, err => {
      this._toastService.error('Błąd pobierania.' );
      this.downloadsFilesObs.next(null);
    });
  }

  getItems(type) {

    let userType;
    switch (type) {
      case 'partner':
      userType = 'se_partner';
      break;
      case 'se':
      userType = 'se_expert';
      break;
      case 'se_top':
      userType = 'se_top';
      break;
    }

    this.dataService.invoke(`/platform/downloads/business-salonexpert`, 'get', { perPage: 1000 })
      .pipe(
        tap(val => {
          const result = val.data.filter(elem => elem && elem[userType] === true);
          result.forEach(item => {
            this.ngxSmartModalService
            .create(`downloadItem_${item.slug}`, DownloadModalComponent, {
              escapable: false,
              dismissable: false,
              customClass: 'download-modal'
            })
            .setData(item);
            const index = _.findLastIndex(this.categories, { slug: item.category.slug });
            if (index === -1) {
              const category = { ...item.category, files: [item] }
              this.categories.push(category);
            } else {
              this.categories[index].files.push(item);
            }
          });
          this.downloads = val;
        }),
      )
      .subscribe(
        res => {
          this.downloadsObs.next(res);
        },
        err => {

        }
      );
  }
}
